export const en = {
  // Common UI elements
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    loading: "Loading",
    noRecords: "No Records",
    submit: "Submit",
    submitting: "Submitting...",
    saving: "Saving...",
    creating: "Creating...",
    deleting: "Deleting...",
    create: "Create",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    status: "Status",
    back: "Back",
    next: "Next",
    previous: "Previous",
    close: "Close",
    open: "Open",
    yes: "Yes",
    no: "No",
    confirm: "Confirm",
    language: "Language",
    error: "Error",
    profile: "Profile",
    details: "Details",
    country: "Country",
    title: "Title",
    description: "Description",
    optional: "Optional",
    total: "Total",
    price: "Price",
    quantity: "Quantity",
    continue: "Continue",
    finish: "Finish",
    skip: "Skip",
    completed: "Completed",
    required: "Required",
    free: "Free",
    info: "Info",
    noImage: "No Image",
  },

  // Status values (order, fulfilment, payment, withdrawal, etc.) – use with getStatusTranslation
  statuses: {
    order: {
      pending: "Pending",
      processing: "Processing",
      shipped: "Shipped",
      delivered: "Delivered",
      cancelled: "Cancelled",
      confirmed: "Confirmed",
      in_progress: "In Progress",
      pending_approval: "Pending Approval",
      unfulfilled: "Unfulfilled",
      fulfilled: "Fulfilled",
      waiting_for_delivery: "Waiting for Delivery",
      waiting_for_payment: "Waiting for Payment",
      fraud_check: "Fraud Check",
      completed: "Completed",
    },
    fulfilment: {
      fulfilled: "Fulfilled",
      not_fulfilled: "Not Fulfilled",
      unfulfilled: "Unfulfilled",
      partial: "Partially Fulfilled",
      shipped: "Shipped",
      waiting_for_delivery: "Waiting for Delivery",
      waiting_for_payment: "Waiting for Payment",
      fraud_check: "Fraud Check",
      completed: "Completed",
    },
    refund: {
      completed: "Completed",
      approved: "Approved",
      pending: "Pending",
      processing: "Processing",
      in_progress: "In Progress",
      initiated: "Initiated",
      rejected: "Rejected",
      failed: "Failed",
      cancelled: "Cancelled",
      error: "Error",
    },
    withdrawal: {
      approved: "Approved",
      created: "Pending",
      rejected: "Rejected",
    },
    transaction: {
      captured: "Captured",
      pending: "Pending",
      authorized: "Authorized",
      refunded: "Refunded",
      failed: "Failed",
      cancelled: "Cancelled",
      requires_action: "Requires Action",
    },
    streamer: {
      approved: "Approved",
      pending: "Pending",
      rejected: "Rejected",
    },
    lottery: {
      active: "Active",
      completed: "Completed",
      cancelled: "Cancelled",
      waiting_for_approval: "Waiting for Approval",
    },
  },

  bankDetails: {
    book: {
      description:
        "View and update your bank details. You can add as many as you like. Saving your bank details will make them available during withdrawals.",
      noAddress:
        "You don't have a delivery address yet. Please add an address.",
      noBankDetails:
        "You don't have any bank details yet. Please add your bank details.",
    },
    page: {
      title: "Bank Details",
      description: "View your bank details",
    },
  },
  address: {
    book: {
      description:
        "View and update your shipping addresses. You can add as many as you like. Saving your addresses will make them available during checkout.",
      noAddress:
        "You don't have a delivery address yet. Please add an address.",
    },
  },
  cartTotals: {
    subtotal: "Subtotal (excl. shipping and taxes)",
    discount: "Discount",
    total: "Total",
  },
  cartDropdown: {
    title: "Cart",
    variant: "Variant",
    quantity: "Quantity",
    unitPrice: "Unit Price",
    unitTypes: {
      Piece: "Piece",
      KG: "KG",
      Ton: "Ton",
      Meter: "Meter",
      "m²": "m²",
    },
    noExtraInfo: "No extra info",
    subtotal: "Subtotal",
    subtotalNote: "(excl. taxes)",
    remainingToPay: "Remaining To Pay",
    goToCart: "Go to cart",
    empty: "Your shopping bag is empty.",
    exploreProducts: "Explore products",
    exploreProductsSr: "Go to all products page",
  },

  // Navigation
  navigation: {
    home: "Home",
    categories: "Categories",
    products: "Products",
    cart: "Cart",
    account: "Account",
    orders: "Orders",
    checkout: "Checkout",
    search: "Search",
    menu: "Menu",
    close: "Close",
  },

  // Promotion
  promotion: {
    copy: "Copy",
    copiedToClipboard: "Copied to clipboard",
    dontShowAgain: "Don't show again",
    closePopup: "Close popup",
  },

  // Home
  home: {
    discoverAll: "DISCOVER ALL",
    popularGames: "POPULAR PRODUCTS",
    homeProducts: "Home Products",
    allCategories: "All Categories",
    discounted: "Discounted",
    discountPercent: "{{percent}} Discount",
    productBeingSupplied: "Product Being Supplied.",
  },

  blog: {
    brand: "101yapi Blog",
    heroTitle: "Building materials, application guides, and project ideas",
    heroDescription:
      "A knowledge hub that supports 101yapi product pages with product selection, installation tips, material comparisons, and regional project guides.",
    searchPlaceholder: "Search blog posts",
    clearFilters: "Clear filters",
    postsShowing: "{{count}} blog posts shown",
    featured: "Featured",
    readArticle: "Read article",
    read: "Read",
    noPosts: "No blog posts match the selected filters.",
    categories: "Categories",
    tags: "Tags",
    readTime: "{{count}} min",
    backToBlog: "Back to blog",
    author: "Author",
    content: "Content",
    relatedProducts: "Related products",
    relatedCategories: "Related categories",
    recommendedWithArticle: "Recommended with this article",
    linkedProducts: "Linked products",
    linkedProductsDescription:
      "Products directly related to the article you are reading. Open the details to review stock and specifications.",
    discountPercent: "{{percent}}% off",
    noPrice: "No price information",
    goToProduct: "Go to product",
    relatedPosts: "Related posts",
  },

  // Cart
  cart: {
    title: "Cart",
    empty: "Your cart is empty",
    emptyDescription: "Add products to start shopping",
    item: "Item",
    quantity: "Quantity",
    price: "Price",
    subtotal: "Subtotal",
    total: "Total",
    checkout: "Checkout",
    remove: "Remove",
    clear: "Clear Cart",
    continueShopping: "Continue Shopping",
    emptyTitle: "Your cart is empty!",
    emptyMessage:
      "To fill your cart with the products and opportunites of 101yapi, you may now start discover our products.",
    continueShoppingButton: "Continue Shopping",
    priceChangesDetected: "Price Changes Detected",
    priceChangesDescription:
      "Some items in your cart have had their prices updated. Please review the changes below.",
    priceIncreases: "Price Increases",
    priceDecreases: "Price Decreases",
    continueWithUpdatedPrices: "Continue with Updated Prices",
    variantUndefined: "Variant is undefined",
    productTitle: "Product title",
    productImage: "Product image",
    promoCode: "Promo Code",
    off: "off",
    availableProducts: "available products",
    basket: "basket",
    apply: "Apply",
    applying: "Applying...",
    applied: "Applied",
    minimumOrderValue: "Minimum order value",
    select: "Select...",
    yourCart: "Your Cart",
    items: "items",
    failedToUpdateCart: "Failed to update cart",
    updatingQuantity: "Updating quantity...",
    quantityUpdated: "Quantity updated!",
    failedToUpdateQuantity: "Failed to update quantity.",
    noMoreStockAvailable:
      "There is no more stock available for this product. You cannot increase the quantity further.",
    failedToDecreaseQuantity:
      "The quantity could not be decreased. Please try again.",
    itemRemoved: "Item removed from cart",
    failedToRemoveItem: "Failed to remove item from cart",
    couponAppliedSuccess: "Coupon applied successfully",
    couponNotValid: "This coupon is not valid for any products in your cart",
    invalidCouponCode: "Invalid coupon code",
    couponAlreadyUsed:
      "You have already used this coupon. Each coupon can only be used once per customer.",
    couponNotAvailableForGroup:
      "This coupon is not available for your customer group.",
    minimumOrderNotMet:
      "Your order amount doesn't meet the minimum requirement for this coupon.",
    discountsCannotBeApplied:
      "Discounts cannot be applied to the products in your cart.",
    unitPrice: "Unit Price",
    totalPrice: "Total Price",
    cartItems: "Cart Items",
    seller: "Seller",
    noExtraInfo: "No extra info",
    promotionNotApplicable: "Promotion Not Applicable",
    applyCoupon: "Apply Coupon",
    enterCouponCode: "Enter coupon code",
    availablePromotions: "Available Promotions",
    cartSummary: "Cart Summary",
    tax: "Tax",
    commission: "Commission",
    shipping: "Shipping",
    shippingAdjustments: "Shipping Adjustments",
    totalAmount: "Total Amount",
    discount: "Discount",
    walletPaymentAmount: "Wallet Payment Amount",
    remainingToPay: "Remaining To Pay",
    completeCheckout: "Complete Order",
    signIn: "Sign In",
    termsAgreement:
      "By proceeding, you agree to our Terms of Service and Privacy Policy",
    needHelp: "Need Help?",
    customerServiceAvailable:
      "Our customer service team is available 24/7 to assist you with any questions.",
    contactSupport: "Contact Support",
    removeItem: "Remove Item",
    removeItemConfirm:
      "Are you sure you want to remove this item from your cart?",
    cancel: "Cancel",
    loginRequired: "Login Required",
    loginRequiredForCoupons:
      "To use discount coupons, please sign in to your account.",
    close: "Close",
    cartUpdateRequired: "Cart Update Required",
    partialPaymentDetected:
      "Partial wallet payment detected. To ensure a secure checkout, your previous cart is preserved. Please clear your guest cart or continue with your current items.",
    clearGuestCart: "Clear Guest Cart",
    continueWithCurrentCart: "Continue with Current Cart",
    guestCartCleared: "Guest cart cleared successfully!",
    yourCartIsEmpty: "Your cart is empty",
    looksLikeEmpty: "Looks like you haven't added anything to your cart yet.",
    startShopping: "Start Shopping",
    digitalProductsNotice:
      "You have physical products in your cart. Items will be delivered to your address via standard shipping.",
    promotionsApplied: "Promotion(s) applied:",
    removePromotionSr: "Remove promotion from order",
  },

  // Product
  product: {
    addToCart: "Add to Cart",
    addingToCart: "Adding...",
    calculate: "Calculate",
    width: "Width (cm)",
    length: "Length (cm)",
    thickness: "Thickness (cm)",
    quantity: "Quantity",
    area: "Enter the area you want to cover (m²)",
    recommendedPieces: "Recommended quantity including 10% waste allowance: {{count}} pieces",
    recommendedArea: "Recommended quantity including 10% waste allowance: {{count}} m²",
    dimensionsInstruction: "Please enter dimensions in centimeters (cm).",
    totalArea: "Total Area (m²)",
    recommendedPackages: "Recommended Packages",
    viewDetails: "View Details",
    buyNow: "Buy Now",
    outOfStock: "Out of Stock",
    inStock: "In Stock",
    description: "Description",
    specifications: "Specifications",
    reviews: "Reviews",
    relatedProducts: "Related Products",
    // Product Tabs
    productDescription: "Product Description",
    campaigns: "Campaigns",
    reviewsCount: "Reviews ({{count}})",
    refundPolicy: "Refund Policy",
    ageRestrictions: "Age Restrictions",
    systemRequirements: "System Requirements",
    howToUse: "How to Use",
    platforms: "Platforms",
    regions: "Regions",
    supportedPlatforms: "Supported Platforms",
    availableRegions: "Available Regions",
    noPlatformInfo: "No platform information available.",
    noRegionInfo: "No region information available.",
    ageClassificationSystem: "Age classification system",
    noSpecificAgeRestrictions: "No specific age restrictions",
    noAgeRestrictionInfo: "No age restriction information available.",
    noSystemRequirements: "No system requirements available.",
    noHowToInfo: "No how-to information available.",
    noRefundPolicyInfo: "No refund policy information available.",
    noSeoData: "No SEO data.",
    metaTitle: "Meta Title",
    metaDescription: "Meta Description",
    metaKeywords: "Meta Keywords",
    seoContent: "SEO Content",
    anonymous: "Anonymous",
    mustPurchaseToReview:
      "You must purchase the product before you can leave a review.",
    youMightAlsoLike: "You might also want to check out these products.",
    price: "Price",
    noStockAvailable: "No stock available for this item",
    addToCartFailed: "Failed to add item to cart. Please try again.",
    variantRequiredGoToDetails:
      "Options are required for this product. Please open the detail page first.",
    off: "% OFF",
    productBeingSupplied: "Product Being Supplied",
    epinDeliveryInfo: "Prepared and shipped based on stock availability.",
    notEligibleForPromotion:
      "This product is not eligible for promotion codes or discounts.",
    partialPaymentWarning:
      "You have a cart with partial payment. Please complete your current order before adding more items.",
    decreaseQuantity: "Decrease quantity",
    increaseQuantity: "Increase quantity",
    quantityLabel: "Quantity",
    maxQuantityReached: "You have reached the maximum available for this item",
    completeCurrentOrder: "Complete Current Order",
    selectVariant: "Select variant",
    productImage: "Product image",
    promotionNotApplicable: "Promotion Not Applicable",
    comments: "Comments",
    rateProduct: "Rate Product",
    addToFavorites: "Add to Favorites",
    removeFromFavorites: "Remove from Favorites",
    favoriteAddedSuccess: "Product added to favorites!",
    favoriteRemovedSuccess: "Product removed from favorites.",
    favoriteError: "Failed to update favorites.",
    favoriteAuthRequired: "Please log in to add items to favorites.",
    noVariantSelected: "Please select a product variant.",
    favorites: "Favorites",
    favoritesDescription:
      "Here you can view and manage your favorite products.",
    noFavoritesYet: "No favorite products yet.",
    noFavoritesDescription:
      "Add products you love to your favorites to easily find them later.",
    browseProducts: "Browse Products",
    noImage: "No Image",
    moreFromCategory: "More from this category",
    discoverMoreProducts: "Discover other products in the same category",
    canActivateIn: "Can activate in",
    region: "Region",
    platform: "Platform",
    type: "Type",
    topUp: "Top-up",
    notSpecified: "Not specified",
    rating: "Rating",
    rateStars: "Rate {{count}} stars out of 5",
    yourReview: "Your Review",
    reviewPlaceholder: "What did you like or dislike about this product?",
    submitting: "Submitting...",
    submitReview: "Submit Review",
    reviewSubmittedSuccess: "Review submitted successfully!",
    reviewError: "Something went wrong. Please try again.",
    reviewErrorGeneric: "An error occurred. Please try again.",
    products: "Products",
    productInformation: "Product Information",
    shippingReturns: "Shipping & Returns",
    material: "Material",
    fastDelivery: "Fast delivery",
    fastDeliveryDescription:
      "Your package will arrive in 3-5 business days at your pick up location or in the comfort of your home.",
    simpleExchanges: "Simple exchanges",
    simpleExchangesDescription:
      "Is the fit not quite right? No worries - we'll exchange your product for a new one.",
    easyReturns: "Easy returns",
    easyReturnsDescription:
      "Just return your product and we'll refund your money. No questions asked – we'll do our best to make sure your return is hassle-free.",
    addedToCart: "Added to Cart",
    seller: "Seller",
    goToCart: "Go to Cart",
    continueShopping: "Continue Shopping",
    similarProducts: "Similar Products",
    preview: "Preview",
    totalAmount: "Total Amount",
    fieldRequired: "{{field}} is required",
    fieldMinLength: "{{field}} must be at least {{min}} characters",
  },

  // Checkout
  checkout: {
    title: "Checkout",
    shippingAddress: "Shipping Address",
    paymentMethod: "Payment Method",
    orderSummary: "Order Summary",
    subtotal: "Subtotal",
    shipping: "Shipping",
    tax: "Tax",
    total: "Total",
    placeOrder: "Place Order",
    backToCart: "Back to Cart",
    processing: "Processing...",
    success: {
      orderPlaced: "Your order has been placed successfully",
      walletPayment: "Payment successful",
    },
    error: "An error occurred while placing your order",
    empty: {
      title: "Your cart is empty",
      description:
        "Looks like you have not added anything to your cart yet. Start browsing to find something you love.",
      startShopping: "Start Shopping",
    },
    notices: {
      digital:
        "You have physical products in your cart. Items will be delivered to your address via standard shipping.",
      physical:
        "The product is a physical product. Please fill in the address information.",
      digitalOnly: "This is a physical product. Delivery address is required.",
    },
    payment: {
      methodTitle: "Payment Method",
      wallet: {
        title: "Pay with wallet",
        secure: "Secure wallet payment",
        balance: "Your wallet usable balance:",
        enterAmount: "Enter Amount to Pay",
        maxAmount: "Max: {{amount}}",
        payNow: "Pay Now",
        processing: "Processing...",
        noCommission: "No commission fees for wallet payments!",
      },
      creditCard: {
        title: "Pay with credit card",
      },
      bankTransfer: {
        title: "Pay with bank transfer",
      },
      common: {
        secure: "Your money and privacy is always secure",
        fast: "Fast payment, no wait",
        totalPaymentWithCommission:
          "Total Payment: {{total}} ({{commission}}% commission applied)",
      },
    },
    savedAddresses: {
      title: "Saved Addresses",
      helper:
        "Choose one of your saved addresses to auto-fill billing and delivery details.",
      placeholder: "Select one of your saved addresses",
      greetingPrompt:
        "Hi {{name}}, do you want to use one of your saved addresses?",
    },
    billing: {
      title: "Billing information",
      type: "Billing Type",
      typePlaceholder: "Select billing type",
      individual: "Individual",
      corporate: "Corporate",

      saveAddressLabel: "Save this address to my account for future orders",
      saveAddressInfo:
        "Address save form opened! Your billing information has been pre-filled.",
    },
    addAddressModal: {
      title: "Save Address to Account",
      saveButton: "Save Address",
    },
    fields: {
      firstName: "First Name",
      lastName: "Last Name",
      tcNo: "National ID No (Optional)",
      birthDate: "Date of Birth (Required)",
      phone: "Phone",
      email: "Email Address",
      companyName: "Company Name",
      taxOffice: "Tax Office",
      taxNo: "Tax No",
      country: "Country",
      city: "City",
      district: "District",
      address: "Billing Address",
      deliveryFirstName: "Delivery First Name",
      deliveryLastName: "Delivery Last Name",
      deliveryPhone: "Delivery Phone",
      deliveryAddress: "Delivery Address",
    },
    placeholders: {
      selectCountry: "Select country",
      selectCity: "Select city",
      selectDistrict: "Select district",
    },
    delivery: {
      title: "Delivery information",
      useBilling: "Use Billing Information as Delivery Information",
    },
    agreements: {
      title: "Agreement & forms",
      preContractualTitle: "Pre-Contractual information form",
      readMore: "Read more",
      distanceSellingTitle: "Distance Selling Agreement",
      distanceSellingDescription:
        "This agreement outlines the terms and conditions for distance selling transactions.",
    },
    summary: {
      title: "Order Summary",
      couponNotice:
        "To use discount coupons, go back to Cart page to add coupons.",
      shipping: "Shipping",
      shippingAdjustments: "Shipping Adjustments",
      tax: "Tax",
      commission: "Commission",
      discount: "Discount",
      subtotal: "Subtotal",
      walletPaymentAmount: "Wallet Payment Amount",
      remainingToPay: "Remaining To Pay",
      totalAmount: "Total Amount",
      terms:
        "I read and agree to the terms and conditions. I agree to receive SMS about order updates.",
      completing: "Completing...",
      completeCheckout: "Complete Order",
      securePayment: "Secure payment",
      enterCoupon: "Enter coupon code",
      apply: "Apply",
    },
    errors: {
      requiredFields: "Please fill in required fields: {{fields}}",
      selectCityDistrict: "Please select city and district",
      billingAddressMissing:
        "Please complete billing address (country, address)",
      deliveryInfoMissing: "Please complete delivery information: {{fields}}",
      deliveryCityDistrictMissing:
        "Please select city and district for delivery",
      processing: "An error occurred while processing the payment",
      unknown: "Unknown error occurred",
      customerBalanceMissing: "Customer balances not available",
      amountExceeds: "Amount cannot exceed {{amount}}",
      insufficientBalance: "Insufficient balance",
      agreeToTermsRequired:
        "You must agree to the terms and conditions to proceed with payment.",
    },
  },

  // Payment success page
  paymentSuccess: {
    loadingOrderDetails: "Loading order details...",
    depositSuccessful: "Deposit successful!",
    paymentSuccess: "Payment success!",
    productImage: "Product image",
    seller: "Seller",
    orderSummary: "Order Summary",
    subtotal: "Subtotal",
    discount: "Discount",
    totalPaid: "Total Paid",
    remainingToPay: "Remaining to Pay",
    refresh: "Refresh",
    goToWallet: "Go to Wallet",
    close: "Close",
  },

  // Order success page
  orderSuccess: {
    eyebrow: "Order received",
    title: "Your order has been successfully received",
    description:
      "Our customer representative will review your order details and contact you as soon as possible.",
    orderNumber: "Order No:",
    contactLabel: "Contact number",
    homeButton: "Back to homepage",
    continueShopping: "Continue shopping",
  },

  // Wallet
  wallet: {
    tabs: {
      wallets: "Wallets",
      deposit: "Load Balance",
      transactions: "Wallet Transactions",
      withdrawals: "Withdrawals",
      withdrawalTransactions: "Withdrawals Transactions",
    },
    load: {
      title: "Load Balance",
      subtitle:
        "Discover limitless shopping now by adding credit to your wallet.",
      error: "Failed to load payment gateways.",
      creditTab: "Credit Card",
      bankTab: "Bank Transfer",
      enterAmount: "Enter Amount",
      proceed: "Proceed to payment",
      totalWithCommission:
        "Total Payment: {{total}} ({{commission}}% commission applied)",
      commissionApplied: "({{commission}}% commission applied)",
      amountTransferred: "Amount to be Transferred to Your Account: {{amount}}",
      errorMessage: "Error message: {{message}}",
      goToIdVerification: "Go to the ID Verification page",
    },
    balance: {
      transferTitle: "Balance transfer",
      transferDesc: "Send your balance to your friend or another account.",
      targetEmail: "Target Account email address",
      transferAmount: "Transfer amount",
      save: "Save",
    },
    transactions: {
      title: "Wallet transactions",
      loading: "Loading...",
      error: "Failed to load transactions.",
      id: "ID",
      balanceType: "Balance Type",
      transaction: "Transaction",
      amount: "Amount",
      balance: "Balance",
      reason: "Reason",
      createdAt: "Created At",
      empty: "No transactions found.",
      balanceTypes: {
        inAppBalance: "In-App Balance",
        withdrawalBalance: "Withdrawal Balance",
        blockedBalance: "Blocked Balance",
        bonusBalance: "Bonus Balance",
      },
      transactionTypes: {
        payment: "Payment",
        addBalance: "Add balance",
        depositRelease: "Deposit release",
        addInAppBalance: "Add In-App Balance",
        refund: "Refund",
      },
    },
    withdrawals: {
      title: "Transfers and Chargebacks",
      subtitle:
        "Transfer the cash from your wallet to the account you paid with.",
      limit: "The amount to withdraw is limited to {{amount}} TRY",
      addNew: "Add new details",
      useSaved: "Use saved details",
      success: "Withdrawal request created successfully",
      invalidAmount: "Please enter a valid positive amount",
      exceedsBalance:
        "The amount you have requested is greater than your current balance. Your current balance is {{balance}} TRY",
      newData: {
        important: "Important Announcement:",
        transferInfo:
          "You can transfer the balance you earn by selling on our site to your bank account.",
        verifyPrefix:
          "Before submitting a withdrawal request, please verify your identity information in the",
        userInfoLink: "'My User Information'",
        verifySuffix: " section.",
        processingHours:
          "Cash withdrawal requests for balances will be processed between 09:00 and 04:00.",
        minAmount:
          "You can request cash withdrawals for balances of 30 TL or more.",
        feeInfo:
          "For EFT or wire transfer transactions, a fee of 5 TL will be deducted from the requested amount for all banks.",
        iban: "IBAN",
        accountName: "Account Name",
        phoneNumber: "Phone Number",
        amount: "Amount",
        amountTransfer:
          "The amount to be transfered to the account: {{amount}} TL",
        fastPayment: "Fast payment",
        saveInfos: "Save my infos",
        createRequest: "Create request",
      },
    },
    withdrawalsTransactions: {
      title: "Balance withdrawal requests",
      loading: "Loading...",
      error: "Failed to load transactions.",
      type: "Type",
      fast: "Fast",
      normal: "Normal",
      accountInfo: "Account Information",
      amount: "Amount",
      commission: "Commission",
      createdAt: "Created at",
      status: "Status",
      detailsTitle: "Withdrawal Details",
      bank: "Bank",
      account: "Account",
      iban: "IBAN",
      reason: "Reason",
      cancel: "Cancel",
      close: "Close",
      empty: "No transactions found",
    },
  },

  // Order
  order: {
    title: "My Orders",
    orderNumber: "Order Number",
    date: "Date",
    status: "Status",
    total: "Total",
    viewDetails: "View Details",
    tracking: "Track Order",
    noOrders: "You don't have any orders yet",
    pending: "Pending",
    processing: "Processing",
    shipped: "Shipped",
    delivered: "Delivered",
    cancelled: "Cancelled",
  },

  // Order Details (single order page)
  orderDetails: {
    backToOverview: "Back to overview",
    title: "Order details",
    confirmationSent: "We have sent the order confirmation details to",
    orderDate: "Order date:",
    orderNumber: "Order number:",
    orderStatus: "Order status:",
    orderSummary: "Order Summary",
    subtotal: "Subtotal",
    discount: "Discount",
    totalPaid: "Total Paid",
    refunded: "Refunded",
    payment: "Payment",
    paymentMethod: "Payment method",
    paymentDetails: "Payment details",
    status: "Status",
    paidAt: "paid at",
    wallet: "Wallet",
    card: "Card",
    paymentLabel: "Payment",
    needHelp: "Need help?",
    contact: "Contact",
    returnsExchanges: "Returns & Exchanges",
    code: "Code:",
    codeCopiedToClipboard: "Code copied to clipboard",
    refund: "Refund:",
    price: "Price:",
    youSave: "Save",
  },

  // Order Tracking (guest/logged-in track by order number)
  orderTracking: {
    title: "Order Tracking",
    subtitle: "Enter your order number to track your order status.",
    enterOrderNumber: "Please enter your order number.",
    orderNotFound: "Order not found. Please check your order number.",
    searchError:
      "An error occurred while searching for your order. Please try again later.",
    howItWorks: "How Order Tracking Works",
    step1Title: "1. Enter Order Number",
    step1Description: "Use the order number sent to your email.",
    step2Title: "2. View Status",
    step2Description: "See the current status and details of your order.",
    step3Title: "3. Track Progress",
    step3Description: "Follow your order through every step until delivery.",
    inputPlaceholder: "Enter your order number",
    reset: "Reset",
    loadingTrack: "Loading...",
  },

  // Search
  search: {
    placeholder: "Search products...",
    noResults: "No results found",
    results: "Results",
    filters: "Filters",
    sort: "Sort",
    clear: "Clear",
    resultsTitle: "Search results",
    searching: "Searching...",
    emptyStateTitle: "Start your search",
    emptyStateHint:
      "Type at least 3 characters to search products and categories.",
    noResultsForQuery: 'No results for "{{query}}". Try different keywords.',
    resultsCount: "{{count}} results found",
    priceUnavailable: "Price unavailable",
    resultTypeCategory: "Category",
    resultTypeProduct: "Product",
    countrySearchPlaceholder: "Search country...",
    countryNotFound: "No country found.",
  },

  // Category
  category: {
    all: "All",
    noProducts: "No products found in this category",
    filters: "Filters",
    sort: "Sort",
  },

  // Footer
  contactBanner: {
    contactUs: "Contact Us",
    contactUsDescription: "Contact us for your questions",
    followUs: "Follow us",
    socialMediaAccounts: "Our social media accounts",
  },

  // Footer
  footer: {
    about: "About Us",
    contact: "Contact",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    support: "Support",
    newsletter: "Newsletter",
    subscribe: "Subscribe",
    popularCategories: "Popular Categories",
    corporate: "Corporate",
    agreements: "Agreements",
    member: "Member",
    taxOfficeNumber: "Tax Office / Number",
    company: "Company",
    address: "Address",
    customerSupport: "Customer support",
    defaultAddress: "LEFKOŞA / CYPRUS",
    copyright: "© {{year}} 101yapi. All rights reserved.",
  },

  // Errors
  error: {
    general: "An error occurred",
    network: "Network error",
    notFound: "Page not found",
    unauthorized: "Unauthorized",
    server: "Server error",
    tryAgain: "Try Again",
  },

  // Sign In
  signIn: {
    title: "Sign in",
    description: "Sign in to your 101yapi account.",
    email: "Email",
    emailPlaceholder: "Enter your email address",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    loginButton: "SIGN IN",
    registerButton: "REGISTER",
    forgotPassword: "Forgot Password?",
    disclosureText: "Click to Read the Disclosure Text!",
    or: "OR",
    infoTitleLine1: "Start Benefiting",
    infoTitleLine2: "from Privileges",
    infoTitleLine3: "by Signing In",
  },

  // Sign Up
  signUp: {
    title: "Sign Up",
    description: "Create a new 101yapi account.",
    firstName: "First Name",
    firstNamePlaceholder: "Enter your first name",
    lastName: "Last Name",
    lastNamePlaceholder: "Enter your last name",
    phone: "Your Phone Number",
    phonePlaceholder: "Enter your phone number",
    email: "Email",
    emailPlaceholder: "Enter your email address",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    kvkkText: "KVKK Text",
    kvkkRead: "I have read",
    termsText: "Membership Agreement",
    termsRead: "I have read",
    registerButton: "REGISTER",
    processing: "PROCESSING...",
    disclosureText: "Click to Read the Disclosure Text!",
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    emailInvalid: "Invalid email address",
    passwordMinLength: "Password must be at least 8 characters long.",
    phoneInvalid: "Turkish phone number must be 12 digits",
    phoneAlreadyInUse: "This phone number is already in use",
    kvkkRequired: "You must accept KVKK",
    termsRequired: "You must accept Terms of Use",
    registrationFailed: "Registration failed",
    infoTitleLine1: "Start Benefiting",
    infoTitleLine2: "from Privileges",
    infoTitleLine3: "by Signing Up",
    haveAccount: "Already have an account?",
    signInLink: "SIGN IN!",
    countryCode: "Country Code",
  },

  // Forgot Password
  forgotPassword: {
    title: "Forgot Password",
    description: "Enter your email address to reset your password.",
    step1Description: "We will send a verification code to your email address",
    step2Description: "Enter the 6-digit code sent to your email address",
    step3Description: "Set a new password for your account",
    email: "Email Address",
    emailPlaceholder: "example@email.com",
    verificationCode: "6-Digit Verification Code",
    codeSentTo: "We sent the code to {{email}}",
    enterEmailAndCode: "Enter your email address and verification code",
    newPassword: "New Password",
    newPasswordPlaceholder: "At least 6 characters",
    confirmPassword: "New Password (Repeat)",
    confirmPasswordPlaceholder: "Re-enter your password",
    sendCodeButton: "Send Verification Code",
    verifyButton: "Verify Code",
    updatePasswordButton: "Update Password",
    sending: "Sending...",
    verifying: "Verifying...",
    updating: "Updating...",
    passwordsMatch: "✓ Passwords match",
    passwordsNotMatch: "✗ Passwords do not match",
    codeSentSuccess: "Verification code has been sent to your email address",
    codeVerifiedSuccess: "Code verified successfully",
    passwordUpdatedSuccess:
      "Your password has been updated successfully. Redirecting to login page...",
    passwordsNotMatchError: "Passwords do not match",
    passwordMinLengthError: "Password must be at least 6 characters",
    requestFailed: "Request failed",
    verificationFailed: "Verification failed",
    updateFailed: "Password update failed",
  },

  // ID Verification
  idVerification: {
    title: "Id Verification",
    description: "Id verification upload page",
  },

  // Impersonate
  impersonate: {
    accessDenied: "Access Denied",
    noTokenProvided:
      "No authentication token was provided in the URL. Please use a valid impersonation link.",
    expectedUrlFormat: "Expected URL format:",
    returnToPreviousPage: "Return to Previous Page",
    impersonationSuccessful: "Impersonation Successful",
    authenticatedAsUser:
      "You are now authenticated as the target user. Redirecting to dashboard...",
    redirectingToDashboard: "Redirecting to user dashboard...",
    fullAccessWarning:
      "You now have full access to this user's account. All actions will be logged for security purposes.",
    authenticationFailed: "Authentication Failed",
    unableToComplete: "Unable to complete the impersonation process.",
    whatYouCanDo: "What you can do:",
    requestNewLink: "Request a new impersonation link",
    checkExpired: "Check if the link has expired",
    contactAdmin: "Contact your system administrator",
    goBack: "Go Back",
    authenticating: "Authenticating Impersonation",
    processingToken:
      "Processing your authentication token and establishing user session.",
    allActivitiesLogged:
      "Processing authentication token. All impersonation activities are logged and monitored.",
  },

  // Dashboard
  dashboard: {
    title: "Account",
    description: "Overview of your account activity.",
    overview: "Overview",
    orders: "Orders",
    ordersDescription:
      "View your previous orders and their status. You can also create returns or exchanges for your orders if needed.",
  },

  // Navbar
  navbar: {
    loadBalance: "Load Balance",
    hiddenBalance: "*** TL",
    overview: "Overview",
    profile: "Profile",
    wallet: "Wallet",
    bankDetails: "Bank Details",
    lottery: "Campaign",
    address: "Address",
    orders: "Orders",
    referrals: "Referrals",
    referralTitle: "Referrals",
    referralDescription: "Share your referral link to earn rewards.",
    referralAnalytics: "Referral Analytics",
    referralDailyGains: "Daily Gains",
    referralWeeklyGains: "Weekly Gains",
    referralTotalGains: "Total Gains",
    referralTotalUsers: "Total Referred Users",
    referralCharts: "Referral Gains Charts",
    referralDailyLabel: "Daily Gains",
    referralMonthlyLabel: "Monthly Gains",
    referralTooltipGains: "Gains",
    referralTooltipCount: "Referrals Count",

    streamerSettings: "Dealer Settings",
    streamerMySettings: "My Settings",
    streamerDonations: "Donations",
    streamerSubmitInfo: "Submit Dealer Info",
    streamerPending: "Your dealer application is currently pending review.",
    streamerConnectingTitle: "Connecting Supplier",
    streamerConnectingDescription: "Processing connection...",
    logout: "Log out",
    loading: "Loading...",
  },

  // Navigation Items
  navItems: {
    allGames: "ALL PRODUCTS",
    mobileGames: "HAND TOOLS",
    gameGold: "HIRDAVAT",
    loadId: "CIMENTO",
    subscriptions: "SUBSCRIPTIONS",
    giftCards: "BUILDING MATERIALS",
    streamers: "CORPORATE",
  },

  // Guest Checkout
  guestCheckout: {
    title: "Guest Checkout",
    description:
      "Complete your purchase quickly and securely without creating an account",
    fastPurchaseInfo:
      'Fast purchase system allows you to pay with <b>Credit Card, Debit Card, Salary - Account Card, and All Cards</b>.<br />To see more payment options such as <b>Bank Transfer/EFT</b> without fees, you can <a href="/account/sign-in" class="text-blue-300 underline">log in</a> or <a href="/account/sign-up" class="font-bold text-blue-300 underline">sign up</a>.<br />Your order information will be sent to your email address.',
    physicalProductNotice:
      "The Product is a physical product. Please fill in the address information.",
    error: "Error",
    billingInformation: "Billing Information",
    billingType: "Billing Type",
    selectBillingType: "Select billing type",
    individual: "Individual",
    corporate: "Corporate",

    firstName: "First Name",
    lastName: "Last Name",
    nationalIdOptional: "National ID No (Optional)",
    dateOfBirth: "Date of Birth",
    phone: "Phone",
    emailAddress: "Email Address",
    companyName: "Company Name",
    taxOffice: "Tax Office",
    taxNo: "Tax No",
    country: "Country",
    selectCountry: "Select country",
    city: "City",
    selectCity: "Select city",
    district: "District",
    selectDistrict: "Select district",
    billingAddress: "Billing Address",
    deliveryInformation: "Delivery Information",
    useBillingAsDelivery: "Use Billing Information as Delivery Information",
    deliveryAddress: "Delivery Address",
    invoiceInfo:
      "This information will be used for invoice issuance. It is an e-Archive invoice and will only be sent to your email address.",
    orderSummary: "Order Summary",
    digitalProductsNotice:
      "Products will be delivered to your address via secure shipping.",
    quantity: "Quantity",
    playerId: "Customer Note",
    noExtraInfo: "No extra info",
    noProductsInCart: "There are no products in your cart",
    commission: "Commission",
    shipping: "Shipping",
    free: "Free",
    discount: "Discount",
    subtotal: "Subtotal",
    totalAmount: "Total Amount",
    amountToBePaid: "Amount to be Paid",
    processing: "Processing...",
    selectPaymentMethod: "Select payment method",
    completePurchase: "Complete Purchase",
    securePayment:
      "The payment process is protected by a secure SSL connection",
    selectPaymentMethodError: "Please select a payment method",
    fillRequiredFields: "Please fill in required fields",
    fillRequiredBillingFields:
      "Please fill all required billing fields including Address, Phone and Email",
    fillFirstNameLastName: "Please fill in your first and last name",
    paymentFailed: "Payment failed. Please try again.",
    paymentProcessingFailed: "Payment processing failed",
    loadingPaymentGateways: "Loading payment gateways...",
    failedToLoadGateways: "Failed to load payment gateways.",
    selectPaymentMethodTitle: "Select Payment Method",
    commissionLabel: "Commission",
  },

  // Account Components
  account: {
    // General
    title: "My Account",
    payments: "Payment Methods",
    settings: "Settings",
    logout: "Logout",
    login: "Login",
    register: "Register",
    forgotPassword: "Forgot Password",
    resetPassword: "Reset Password",

    // Account Info
    edit: "Edit",
    cancel: "Cancel",
    saveChanges: "Save changes",
    updatedSuccessfully: "{{label}} updated succesfully",
    errorOccurred: "An error occurred, please try again",

    // Account Nav
    dashboard: "Dashboard",
    profile: "Profile",
    bankDetails: "Bank details",
    lottery: "Campaign",
    wallet: "Wallet",
    addresses: "Addresses",
    orders: "Orders",
    referrals: "Referrals",
    streamerSettings: "Dealer Settings",
    logOut: "Log out",
    account: "Account",
    referralTitle: "Referrals",
    referralDescription: "Share your referral link to earn rewards.",
    referralAnalytics: "Referral Analytics",
    referralDailyGains: "Daily Gains",
    referralWeeklyGains: "Weekly Gains",
    referralTotalGains: "Total Gains",
    referralTotalUsers: "Total Referred Users",
    referralCharts: "Referral Gains Charts",
    referralDailyLabel: "Daily Gains",
    referralMonthlyLabel: "Monthly Gains",
    referralTooltipGains: "Gains",
    referralTooltipCount: "Referrals Count",
    streamerMySettings: "My Settings",
    streamerDonations: "Donations",
    streamerSubmitInfo: "Submit Dealer Info",
    streamerPending: "Your dealer application is currently pending review.",
    streamerConnectingTitle: "Connecting Supplier",
    streamerConnectingDescription: "Processing connection...",

    // Profile Components
    phone: "Phone",
    phonePlaceholder: "Enter Phone Number",
    phoneUpdateFailed: "Failed to update phone number",
    phoneUpdateSuccess: "Phone number updated successfully",
    password: "Password",
    passwordNotShown: "The password is not shown for security reasons",
    oldPassword: "Old password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    name: "Name",
    firstName: "First name",
    lastName: "Last name",
    nameUpdateFailed: "Failed to update name",
    nameUpdateSuccess: "Name updated successfully!",
    profileImage: "Profile Image",
    profileImageUpdateFailed: "Failed to update profile image",
    addProfilePicture: "Add profile picture",
    email: "Email",
    emailUpdateFailed: "Failed to update email",
    billingAddress: "Billing address",
    noBillingAddress: "No billing address",
    company: "Company",
    address: "Address",
    apartmentSuite: "Apartment, suite, etc.",
    postalCode: "Postal code",
    city: "City",
    province: "Province",
    country: "Country",
    selectCountry: "Select country",
    selectCity: "Select city",
    selectDistrict: "Select district",
    billingAddressUpdateFailed: "Failed to update billing address",

    // Referral Card
    yourReferralLink: "Your Referral Link",
    howItWorks: "How it works:",
    shareReferralLink: "Share your unique referral link",
    customersSignUp: "Customers sign up using your link",
    earnRewards: "You earn rewards based on the customer's actions",
    referralLinkCopied: "Referral link copied to clipboard",
    failedToCopyLink: "Failed to copy link",

    // Order Components
    orderId: "Order ID",
    date: "Date",
    total: "Total",
    item: "Item",
    items: "Items",
    seeDetails: "See details",
    qty: "Qty",
    more: "more",
    noOrdersYet: "You don't have any orders yet, let's change that",
    continueShopping: "Continue shopping",
    datePlaced: "Date placed",
    orderNumber: "Order number",
    totalAmount: "Total amount",
    noRecentOrders: "No recent orders",
    streamerSubmitInfoTitle: "Submit Dealer Info",
    streamerSubmitInfoDescription:
      "Fill in the details below to submit your dealer information. Fields marked with * are required.",
    streamerFormStepInfo: "📊 1. Dealer Info",
    streamerFormStepSocial: "🌐 2. Social Media Links",
    streamerFormStepCounter: "Step {current} of {total}",
    streamerUsernameLabel: "Dealer Username",
    streamerUsernamePlaceholder: "Enter your dealer username",
    streamerStreamUrlLabel: "Stream URL",
    streamerStreamUrlPlaceholder: "https://www.twitch.tv/",
    streamerProfilePathLabel: "Dealer Profile Path",
    streamerProfilePathPlaceholder: "Enter your profile path",
    streamerUsernameRequired: "Dealer username is required",
    streamerStreamUrlRequired: "Stream URL is required",
    streamerMpathRequired: "Profile path is required",
    streamerFormCheckInputs: "Please check your form inputs",
    streamerFormSubmittedSuccessfully:
      "Dealer information submitted successfully",
    streamerFormSubmitFailed: "Failed to submit dealer information",
    streamerSubmitInfoButton: "Submit Dealer Info",
    socialTwitch: "Twitch",
    socialYoutube: "YouTube",
    socialDiscord: "Discord",
    socialInstagram: "Instagram",
    socialFacebook: "Facebook",
    socialTwitterX: "Twitter/X",
    socialNimo: "Nimo",
    socialDlive: "DLive",
    socialKick: "Kick",
    socialTiktok: "TikTok",

    // Overview Components
    hello: "Hello",
    signedInAs: "Signed in as:",
    profileTab: "Profile",
    followersTab: "Followers",
    friendsTab: "Friends",
    galleryTab: "Gallery",
    completed: "Completed",
    takeAction: "Take Action",
    totalBalances: "Total Balances",
    about: "About",
    noPostsYet: "No posts yet",
    shareThinking: "Share what you are thinking here...",
    imageVideo: "Image/Video",
    post: "Post",
    likes: "likes",
    writeComment: "Write a comment...",
    gallery: "Gallery",
    followers: "Followers",
    follow: "Follow",
    followed: "Followed",
    yourProfileIsComplete: "Your profile is complete!",
    signUpOrLogin: "Sign up or log in to start completing your profile.",
    addEmailAddress: "Add your email address.",
    completeNameDetails: "Complete your name details.",
    addPhoneNumber: "Add a phone number.",
    setDefaultBillingAddress: "Set a default billing address.",

    // Address Components
    newAddress: "New address",
    addAddress: "Add address",
    editAddress: "Edit address",
    addressName: "Address Name",
    defaultShipping: "Default Shipping",
    defaultBilling: "Default Billing",
    remove: "Remove",
    districtState: "District / State",
    provinceDistrict: "Province / District",

    // Bank Details Components
    newBankDetails: "New Bank Details",
    addBankDetails: "Add Bank Details",
    editBankDetails: "Edit Bank Details",
    phoneNumber: "Phone number",
    iban: "IBAN",
    accountName: "Account Name",
    bankName: "Bank Name",

    // Campaign Components
    lotteries: "Campaigns",
    activeLotteries: "Active Campaigns",
    completedLotteries: "Completed Campaigns",
    allLotteries: "All Campaigns",
    createLottery: "Create Campaign",
    myLotteries: "My Lotteries",
    attendedLotteries: "Attended Lotteries",
    searchLotteries: "Search in lotteries...",
    createNewLottery: "Create a New Campaign",
    fillInfoBelow:
      "Fill in the information below to create a new campaign. All fields marked with * are required.",
    basicInfo: "Basic Info",
    prizeDetails: "Prize Details",
    step: "Step",
    of: "of",
    lotteryTitle: "Campaign Title",
    enterLotteryTitle: "Enter the campaign title",
    enterTaskLinks: "Enter task links one per line",
    lotteryEndDate: "Campaign End Date",
    maxParticipants: "Max Participants",
    ifLeftEmpty: "(If left empty, it will be set to 9999999)",
    lotteryType: "Campaign Type",
    selectLotteryType: "Select campaign type",
    product: "Product",
    balance: "Balance",
    next: "Next",
    selectProduct: "Select Product",
    winnerCount: "Winner Count",
    available: "Available",
    alreadyUsed: "already used",
    add: "Add",
    back: "Back",
    submit: "Submit",
    balanceAmount: "Balance Amount",
    lotteryCreatedSuccess: "Campaign created successfully",
    failedToCreateLottery: "Failed to create campaign",
    pleaseCheckFormInputs: "Please check your form inputs",
    pleaseSelectProduct: "Please select a product and enter winner count",
    winnerCountAtLeast1: "Winner count must be at least 1",
    winnerCountExceedStock: "Winner count cannot exceed remaining stock",
    titleRequired: "Title is required",
    lotteryEndDateMustBeFuture: "Campaign end date must be in the future",
    giftsRequired: "Gifts are required",

    // Delete Account
    deleteMyAccount: "Delete My Account",
    canDeletePermanently: "You can permanently delete your account",
    delete: "Delete",
    confirm: "Confirm",
    emailVerification: "Email",
    areYouSureDelete: "Are you sure you want to delete your account?",
    thisActionCannotBeUndone:
      "This action cannot be undone. All your data will be permanently deleted.",
    yesContinue: "Yes, Continue",
    verifyEmailAddress: "Verify Your Email Address",
    enterEmailToDelete: "Enter your email address to delete your account:",
    emailNotMatching:
      "Email address does not match. Please enter your correct email address.",
    emailVerified: "Email address verified",
    deleting: "Deleting...",
    deleteAccount: "Delete Account",
    accountDeletedSuccess: "Your account has been successfully deleted",
    errorDeletingAccount: "An error occurred while deleting the account",
  },
  variantSelectionModal: {
    title: "Select a variant for {{product}}",
    addToCartTitle: "Select a variant to add {{product}} to cart",
    noImage: "No Image",
    noVariants: "No variants available for this product.",
    addFavorite: "Add favorite",
    removeFavorite: "Remove favorite",
    favoriteAdded: "Added to favorites.",
    favoriteRemoved: "Removed from favorites.",
    favoriteIdNotFound: "Favorite ID not found.",
    unexpectedError: "An error occurred.",
  },
}
